'use strict'

//
// Mutations constants
//

// Initialise store
export const InitialiseStore = 'initialiseStore'

export const ToggleNavBar = 'toggleNavBar'

// Security
export const UpdateCurrentUser = 'updateCurrentUser'
export const UpdateEntryUrl = 'updateEntryUrl'

// Active project
export const UpdateActiveProject = 'updateActiveProject'
export const UpdateLastOrder = 'updateLastOrder'

// Language switch
export const SetLang = 'setLang'

// Shopping cart
export const AddToCart = 'addToCart'
export const ClearCart = 'clearCart'
export const LoadProductList = 'loadProductList'
export const ChangeCheckoutActiveTab = 'changeCheckoutActiveTab'

// Dialogs
export const InfoDialog = 'infoDialog'



// WEBPACK FOOTER //
// ./src/common/store/mutation-types.js